import React, { Component } from "react";
import Select from "react-select";
// import Recaptcha from 'react-recaptcha'
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

class ModalForm extends Component {
  render() {
    return (
      <CardBody className="m-3">
        <Form>
          <Row><Col lg={12}><h2 className="loginText">Create New Account</h2></Col></Row>   
          <Row><Col lg={12}><p className="Practitioner-text">Practitioners</p></Col></Row>
            <Row className="mt-4 mb-2">
              <Col lg={10}>
              <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText className="inputGroupLogin">
                  <i className="bi bi-person-bounding-box inputIconLogin"></i>
                </InputGroupText>
              </InputGroupAddon>
              <Input
                type="text"
                name="vendorFirstName"
                id="vendorFirstName"
                placeholder="First Name"
                onChange={this.props.handleOnChange}
                value={this.props.vendorFirstName}
                // required
                autocomplete="off"
                className="loginOTPStyle inputTextFill"
              />
            </InputGroup>
              </Col>
            </Row>

            <Row>
              <Col lg={10}>
              <InputGroup className="mb-2">
              <InputGroupAddon addonType="prepend">
                <InputGroupText className="inputGroupLogin">
                  <i className="bi bi-person-bounding-box inputIconLogin"></i>
                </InputGroupText>
              </InputGroupAddon>
              <Input
                type="text"
                name="vendorLastName"
                id="vendorLastName"
                placeholder="Last Name"
                onChange={this.props.handleOnChange}
                value={this.props.vendorLastName}
                className="loginOTPStyle inputTextFill"
                // required
                autocomplete="off"
              />
            </InputGroup>
              </Col>
            </Row>

           <Row>
            <Col lg={10}>
            <InputGroup className="mb-2">
              <InputGroupAddon addonType="prepend">
                <InputGroupText className="inputGroupLogin">
                  <i
                    className="bi bi-envelope-fill inputIconLogin"
                    aria-hidden="true"
                  ></i>
                </InputGroupText>
              </InputGroupAddon>
              <Input
                type="email"
                name="vendorEmail"
                id="vendorEmail"
                placeholder="Email Address"
                onChange={this.props.handleOnChange}
                value={this.props.vendorEmail}
                // required
                autocomplete="off"
                className="loginOTPStyle inputTextFill"
              />
            </InputGroup>
            </Col>
           </Row>

           <Row>
            <Col lg={10}>
            <InputGroup className="mb-2">
              <InputGroupAddon addonType="prepend">
                <InputGroupText className="inputGroupLogin">
                  <i className="bi bi-lock-fill inputIconLogin"></i>
                </InputGroupText>
              </InputGroupAddon>
              <Input
                type="password"
                name="vendorPassword"
                id="vendorPassword"
                placeholder="Enter Password"
                onChange={this.props.handleOnChange}
                value={this.props.vendorPassword}
                // required
                className="loginOTPStyle inputTextFill"
                autocomplete="off"
              />
            </InputGroup>
            </Col>
           </Row>
            <Row>
              <Col lg={10}>
              <InputGroup className="mb-5">
              <InputGroupAddon addonType="prepend">
                <InputGroupText className="inputGroupLogin">
                  <i className="bi bi-lock-fill inputIconLogin"></i>
                </InputGroupText>
              </InputGroupAddon>
              <Input
                type="password"
                name="vendorRepeatPassword"
                id="vendorRepeatPassword"
                placeholder="Re-Enter Password"
                onChange={this.props.handleOnChange}
                value={this.props.vendorRepeatPassword}
                // required
                autocomplete="off"
                className="loginOTPStyle inputTextFill"
              />
            </InputGroup>
              </Col>
            </Row>
        </Form>
        <Row className="text-center">
          <Col xs="12" className="mb-3" lg={10}>
            <Button
              className="colorOfBtn"
              id="vendorPreform"
              onClick={(e) => this.props.changeStatusHandler("3")}
              color="warning"
            >
              Next
            </Button>
          </Col>
          <Col xs="12" style={{ textAlign: "end" }} lg={10}>
            <p
              className="createAccount paragraph-style mb-0"
              onClick={(e) => this.props.changeStatusHandler("0")}
            >
              I have an account
            </p>
          </Col>
        </Row>
      </CardBody>
    );
  }
}

export default ModalForm;
